<template>
  <v-container
    id="scelta_lenti"
  >
    <template>
      <span
        v-if="order.monsmo!='S'"
        class="text-h3 text-weigth-light text-uppercase  mt8"
      >Fornitore Lenti</span>
      <span
        v-else
        class="text-h3 text-weigth-light   mt8"
      >Scelta Modello</span>
      <v-row class="my-2" />
      <!-- {{ lens }} -->

      <v-form
        ref="formlenti"
        v-model="validForm"
        lazy-validation
        @submit.prevent="onSubmit()"
      >
        <template v-if="order.monsmo!='S'">
          <template>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-radio-group
                  v-model="lens.lendor"
                  column
                  :rules="[rules.required]"
                  @change="changeLendor"
                >
                  <v-radio
                    label="Lenti  da me ordinate"
                    value="CC"
                  />
                  <v-radio
                    label="Lenti da ordinare per ns. conto"
                    value="CD"
                  />
                  <v-radio
                    v-if="promoMarca.length>0"
                    label="Lenti in promozione"
                    value="PD"
                  >
                    <template v-slot:label>
                      <v-icon color="yellow darken-2">
                        mdi-crown-outline
                      </v-icon> Lenti in promozione
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-autocomplete
                  ref="smarca"
                  v-model="lens.smarca"
                  outlined
                  :items="marcheLenti"
                  :rules="[rules.required]"
                  color="blue-grey lighten-2"
                  label="Ditta Lenti"
                  item-text="ditta"
                  item-value="marca"
                  clearable
                  class="my-0 py-0 text-body-1"
                  height="55px"
                  @change="setDittaLente"
                  @click:clear="$set(lens, 'identi', null); $set(lens, 'altra_ditta_lenti', null);$forceUpdate()"
                >
                  <template v-slot:selection="data">
                    <span>{{ data.item.ditta }}  <small v-if="data.item.idcode">id: {{ data.item.idcode }}</small></span>
                  </template>
                  <template
                    v-slot:item="data"
                  >
                    <span>{{ data.item.ditta }}  <small v-if="data.item.idcode">id: {{ data.item.idcode }}</small></span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-if="lens.lendor=='PD'"
                  v-model="lens.monpro"
                  label="Focale"
                  outlined
                  :items="monpro"
                  :rules="[rules.required]"
                />
                <v-select
                  v-if="lens.lendor=='PD'"
                  v-model="lens.tiptrt"
                  label="Tipologia e Trattamenti"
                  outlined
                  :items="tiptrt"
                  return-object
                  :rules="[rules.required]"
                  @change="setTipTrt"
                >
                  <template v-slot:selection="data">
                    {{ data.item.tipoLente }}  <b class="ml-3">{{ data.item.trtLente }}</b>
                  </template>
                  <template
                    v-slot:item="data"
                  >
                    {{ data.item.tipoLente }} <b class="ml-3">{{ data.item.trtLente }}</b>
                  </template>
                </v-select>

                <v-menu
                  v-if="lens.lendor=='CC'"
                  v-model="menu_data_lenti"
                  :close-on-content-click="false"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="$formatDate(lens.dataord_lenti).substring(0, 10)"
                      label="Data ordine lenti"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      :rules="[rules.required]"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="lens.dataord_lenti"
                    year-icon="mdi-calendar-blank"
                    prev-icon="mdi-skip-previous"
                    next-icon="mdi-skip-next"
                    @input="menu_data_lenti = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="lens.smarca=='AL'">
              <v-col>
                <v-text-field

                  v-model="lens.altra_ditta_lenti"
                  class="mt-0 pt-0"
                  label="Ditta Lenti"
                  :rules="[rules.required]"
                  @blur="$set(lens,'altra_ditta_lenti',lens.altra_ditta_lenti.toUpperCase())"
                />
              </v-col>
              <v-col>
                <v-text-field

                  v-model="lens.identi"
                  class="mt-0 pt-0"
                  label="Cod. Ditta Lenti"
                  :rules="[rules.required]"
                  @blur="$set(lens,'identi',lens.identi.toUpperCase())"
                />
              </v-col>
            </v-row>
          </template>
          <v-divider
            class="ma-4"
            style="border-color:white"
          />
          <!-- ################################## -->
          <v-row class="text-h3 mt-0 ml-3">
            Caratteristiche Lenti
          </v-row>
          <v-row class="text-caption  mb-4 ml-3">
            * Parte da compilare a cura di figura professionale con i requisiti previsti dalla legge cogente e con oggettiva disponibilità di ricetta medica qualora prevista
            <br>
            Attenersi a quanto indicato nel manuale tecnico. In caso di ordinazione lenti da noi non consigliate non ci assumiamo alcuna responsabilità in caso di rotture o difetti
          </v-row>

          <div style="background-color: aliceblue">
            <v-row class="ma-0 pa-0 ">
              <v-col
                cols="12"
                md
                class=" text-center text-h3 text-no-wrap 6"
              >
                OD lente destra
              </v-col>
              <v-col
                class=" text-left text-no-wrap"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="lens.d_filtro"
                  class="ma-0 mt-2 pa-0"
                  label="Filtro Neutro"
                  @change="setFilter('OD')"
                />
              </v-col>
            </v-row>
            <template v-if="!lens.d_filtro">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_sf"
                    v-model="lens.d_vsfero"
                    dense
                    outlined
                    label="SF"
                    :rules="[
                      rules.requiredIf(!lens.d_cilind && !lens.d_addizi),
                      rules.signed,
                      rules.range(-20, 20),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('d_vsfero')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_cyl"
                    v-model="lens.d_cilind"
                    dense
                    outlined
                    label="CYL"
                    :rules="[
                      rules.requiredIf(!lens.d_vsfero && !lens.d_addizi),
                      rules.requiredOn('od_asse'),
                      rules.signed,
                      rules.range(-6, +6),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('d_cilind')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_asse"
                    v-model="lens.d_vlasse"
                    dense
                    outlined
                    label="ASSE"
                    :rules="[
                      rules.requiredOn('od_cyl'),
                      rules.range(1, 180),
                      rules.stepper(1)
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_add"
                    v-model="lens.d_addizi"
                    dense
                    outlined
                    label="ADD."
                    :rules="[
                      rules.requiredIf(!lens.d_vsfero && !lens.d_cilind ),

                      rules.range(+0.75, +3.50),
                      rules.stepper(0.25)
                    ]"
                    :required="(!lens.d_vsfero && !lens.d_cilind )"
                    @blur="ftDecimal('d_addizi')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_prisma"
                    v-model="lens.d_prisma"
                    dense
                    outlined
                    label="PRISMA"
                    :rules="[rules.range(+0.25, +5),rules.stepper(0.25), rules.requiredOn('od_gradi')]"
                    @blur="ftDecimal('d_prisma')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_gradi"
                    v-model="lens.d_vgradi"
                    dense
                    outlined
                    label="GRADI"
                    :rules="[
                      rules.range(+0, +360),
                      rules.stepper(1),
                      rules.requiredOn('od_prisma')
                    ]"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row class="ma-0 pa-0">
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="lens.d_destip"
                  class="uppercase-text"
                  dense
                  outlined
                  label="TIPOLOGIA"
                  :readonly="lens.lendor=='PD'"
                  :rules="[rules.required]"
                  @blur="$set(lens,'d_destip',lens.d_destip.toUpperCase())"
                />
              </v-col>
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="d_destrt"
                  v-model="lens.d_destrt"
                  :readonly="lens.lendor=='PD'"
                  class="uppercase-text"
                  dense
                  outlined
                  label="TRATTAMENTI"
                  @blur="$set(lens,'d_destrt',lens.d_destrt.toUpperCase())"
                />
              </v-col>
            </v-row>
          </div>
          <v-divider
            class="ma-4"
            style="border-color:white"
          />
          <div style="background-color:papayawhip">
            <v-row class="ma-0 pa-0 ">
              <v-col
                cols="12"
                md
                class=" text-center text-h3 text-no-wrap 6"
              >
                OS lente sinistra
              </v-col>
              <v-col
                class=" text-left text-no-wrap"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="lens.s_filtro"
                  class="ma-0 mt-2 pa-0 float-left"
                  label="Filtro Neutro"
                  @change="setFilter('OS')"
                />
                <v-radio-group
                  v-if="!lens.s_filtro"
                  v-model="lens.tabint"
                  class="ma-0 float-right mt-2"
                  row
                  style="border:solid 1px #ccc; border-radius:4px; padding-left:10px; "
                  :rules="
                    (lens.s_vlasse==90 || lens.s_vlasse==180 || !lens.s_vlasse)?
                      []:[rules.required]"
                >
                  <v-radio
                    label="TABO"
                    value="TABO"
                  />
                  <v-radio
                    label="INT"
                    value="INT"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <template v-if="!lens.s_filtro">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_sf"
                    v-model="lens.s_vsfero"
                    dense
                    outlined
                    label="SF"
                    :rules="[
                      rules.requiredIf(!lens.s_cilind && !lens.s_addizi),
                      rules.signed,
                      rules.range(-20, 20),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_vsfero')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_cyl"
                    v-model="lens.s_cilind"
                    dense
                    outlined
                    label="CYL"
                    :rules="[
                      rules.requiredIf(!lens.s_vsfero && !lens.s_addizi),
                      rules.requiredOn('os_asse'),
                      rules.signed,
                      rules.range(-6, +6),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_cilind')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_asse"
                    v-model="lens.s_vlasse"
                    dense
                    outlined
                    label="ASSE"
                    :rules="[
                      rules.requiredOn('os_cyl'),
                      rules.range(1, 180),
                      rules.stepper(1)
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_add"
                    v-model="lens.s_addizi"
                    dense

                    outlined
                    label="ADD."
                    :rules="[
                      rules.requiredIf(!lens.s_vsfero && !lens.s_cilind ),

                      rules.range(+0.75, +3.50),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_addizi')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_prisma"
                    v-model="lens.s_prisma"
                    dense

                    outlined
                    label="PRISMA"
                    :rules="[rules.range(+0.25, +5),rules.stepper(0.25), rules.requiredOn('os_gradi')]"
                    @blur="ftDecimal('s_prisma')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_gradi"
                    v-model="lens.s_vgradi"
                    dense

                    outlined
                    label="GRADI"
                    :rules="[
                      rules.range(0, 360),
                      rules.stepper(1),
                      rules.requiredOn('os_prisma')
                    ]"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row class="ma-0 pa-0">
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="s_destip"
                  v-model="lens.s_destip"
                  class="tipsx uppercase-text"
                  dense
                  outlined
                  :readonly="lens.lendor=='PD'"
                  :rules="[rules.required]"
                  label="TIPOLOGIA"
                  @blur="$set(lens,'s_destip',lens.s_destip.toUpperCase())"
                >
                  <v-tooltip
                    slot="append"
                    attach=".tipsx"
                    nudge-bottom="30"
                    nudge-left="50"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="$set(lens,'s_destip',(lens.d_destip));$forceUpdate();"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span class="text-no-wrap">Copia tip da lente destra</span>
                  </v-tooltip>
                </v-text-field>
              </v-col>
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="s_destrt"
                  v-model="lens.s_destrt"
                  :readonly="lens.lendor=='PD'"
                  class="trtsx uppercase-text"
                  dense
                  outlined
                  label="TRATTAMENTI"
                  @blur="$set(lens,'s_destrt',lens.s_destrt.toUpperCase())"
                >
                  <v-tooltip
                    slot="append"
                    attach=".trtsx"
                    nudge-bottom="30"
                    nudge-left="50"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="$set(lens,'s_destrt',(lens.d_destrt));$forceUpdate()"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span class="text-no-wrap">Copia trt da lente destra</span>
                  </v-tooltip>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <!-- ########################################################## -->
          <v-divider
            class="ma-4"
            style="border-color:white"
          />
          <v-row>
            <v-col
              class="  text-no-wrap"
              cols="12"
              md="2"
            >
              <!-- <v-btn
                    color="primary"
                    x-small
                    class="
                    float-left"
                  >
                    <v-icon
                      x-small
                      v-text="'mdi-square-edit-outline'"
                    />
                  </v-btn> -->

              <v-text-field
                v-model="lens.distan"
                dense

                label="DI"
                placehlder="Distanza Interpupilare"
                readonly
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.d_semidi"
                :disabled="lens.d_filtro"
                dense
                outlined
                label="POD"
                :rules="
                  lens.d_filtro?[]:
                  (!lens.d_vsfero&&lens.d_cilind&&lens.d_vlasse==180)?
                    [rules.range(20, 40),

                    ]:[
                      rules.requiredOn('od_sf'),
                      rules.requiredOn('od_cyl'),
                      rules.requiredOn('od_add'),
                      rules.requiredOn('od_prisma'),
                      rules.range(20, 40),

                    ]"
                @blur="ftDecimal('d_semidi',1)"
                @change="setDistan"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.s_semidi"
                :disabled="lens.s_filtro"
                dense
                outlined
                label="POS"
                :rules="
                  lens.s_filtro?[]:
                  (!lens.s_vsfero&&lens.s_cilind&&lens.s_vlasse==180)?
                    [rules.range(20, 40),

                    ]:[
                      rules.requiredOn('os_sf'),
                      rules.requiredOn('os_cyl'),
                      rules.requiredOn('os_add'),
                      rules.requiredOn('os_prisma'),
                      rules.range(20, 40),

                    ]"
                @blur="ftDecimal('s_semidi',1)"
                @change="setDistan"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.d_altezz"
                :disabled="lens.d_filtro"
                dense
                outlined
                label="HOD"
                :rules="lens.d_filtro?[]:[
                  rules.requiredOn('od_add'),
                  rules.requiredOn('od_prisma'),
                  rules.range(8, 40),

                ]"
                @blur="ftDecimal('d_altezz',1)"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.s_altezz"
                :disabled="lens.s_filtro"
                dense
                outlined
                label="HOS"
                :rules="lens.s_filtro?[]:[
                  rules.requiredOn('os_add'),
                  rules.requiredOn('os_prisma'),
                  rules.range(8, 40),

                ]"
                @blur="ftDecimal('s_altezz',1)"
              />
            </v-col>
          </v-row>
        </template>
        <!-- ################### SCELTA MODELLO E CALIBRO ############################### -->
        <v-row>
          <v-col
            class="  text-no-wrap"
          >
            <v-row
              no-gutters
              align="start"
            >
              <v-img
                :src="lens.desmod!='NN' ? `./img/FRM/${lens.desmod}.png` : './img/noimage.jpg'"
                :lazy-src="'./img/noimage.jpg'"
                max-width="90"
                contain
                class="mb-2 mr-2 pa-0"
              />
              <v-text-field
                v-model="lens.desmod"
                label="Cod. modello"
                outlined
                readonly
                :rules="[rules.required]"
                required
                @click="showForme = true;"
              />
            </v-row>
          </v-col>
          <v-col
            class="  text-no-wrap"
          >
            <v-select
              ref="calibro"
              v-model="lens.calibr"
              :items="rangeCalibro"
              :disabled="!lens.desmod"
              label="Calibro"
              :outlined="!!lens.desmod"
              :rules="!!lens.desmod ? [rules.required] : []"
            />
          </v-col>
          <v-col
            class="  text-no-wrap"
          >
            <v-select
              v-if="order.monsmo!='S'"
              ref="fornitura_lente"
              v-model="lens.fornitura_lente"
              class="ma-0"
              :items="lenssupplier"
              item-text="title"
              return-object
              :disabled="lens.d_filtro && lens.s_filtro"
              label="Modalità Ordine Lenti"
              :outlined="!(lens.d_filtro && lens.s_filtro)"
              :rules="((lens.d_filtro && lens.s_filtro) || lens.lendor=='CC') ? []:[rules.required] "
              clearable
              @change="$set(lens,'diamet',null);"
            />
            <v-text-field
              v-if="!(lens.d_filtro && lens.s_filtro) && lens.fornitura_lente?.value=='diametro'"
              ref="diametro_lente"
              v-model="lens.diamet"
              class="ma-0"
              dense
              reverse
              label="Diametro"
              outlined
              :rules="!(lens.d_filtro && lens.s_filtro) ? [rules.required] : []"
              @input="setDiamet"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="nolens"
          class="ma-0 blue--text"
          style="margin:-25px 0 0 0 !important;"
          @click="showForme=true"
        >
          <v-col
            cols="auto"
            style="cursor:pointer"
          >
            <v-icon>mdi-message-bulleted</v-icon> {{ lens.nolens_detail }}
          </v-col>
        </v-row>
        <!-- <v-btn @click="$refs.formlenti.validate()">
          Validazione
        </v-btn> -->
      </v-form>
    </template>
    <v-dialog
      v-model="showForme"
      scrollable
      max-width="800"
    >
      <v-card>
        <v-col>
          <v-row no-gutters>
            <span class="text-h2 font-weight-light">Modello/Forma Lenti </span>
            <v-spacer />
            <v-btn
              v-if="!nolens"
              x-small
              fab
              @click="showForme = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-divider />
        <v-card-subtitle>
          <v-col cols="12">
            <v-checkbox
              v-model="nolens"
              label="lente non in elenco"
              @change="setDesmod"
            >
              <template v-slot:label>
                <span :class="nolens?'text-h3 font-weight-light black--text':'text-h3 font-weight-light grey--text'">Lente non in elenco</span>
              </template>
            </v-checkbox>
            <v-row v-if="nolens">
              <v-col cols="12">
                <v-textarea
                  v-model="lens.nolens_detail"
                  outlined
                  label="Descrizione caratteristiche e dettagli lente"
                />
              </v-col>
            </v-row>
            <v-text-field
              v-if="!nolens"
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              placeholder="cerca modello lente"
              single-line
              hide-details
              outlined
            />
          </v-col>
        </v-card-subtitle>

        <v-card-text>
          <!-- {{ listalenti }} -->
          <v-data-table
            v-if="!nolens"
            fixed-header
            mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
            dense
            :items="listalenti"
            :headers="headers"
            :search="search"
            item-key="id"
            @click:row="lensClick"
          >
            <template
              v-slot:item.modello="{item}"
            >
              <span class="text-h2 font-weight-light">{{ item.modello }}</span>
            </template>
            <template
              v-slot:item.forma="{item}"
            >
              <v-img
                :src="`./img/FRM/${item.modello}.png`"
                :lazy-src="'./img/noimage.jpg'"
                max-width="150"
                contain
                class="ma-2"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions v-if="nolens">
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="lens.nolens_detail=null; nolens = false"
          >
            Annulla
          </v-btn>
          <v-btn
            color="primary"
            :disabled="lens.nolens_detail==null || lens.nolens_detail.trim()==''"

            @click="showForme = false"
          >
            Conferma
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'SceltaLenti',
    components: {

    },
    props: {
      alive: {
        type: Boolean,
        default: false,
      },
      order: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        loading: false,
        cliente: null,
        validForm: false,
        lens: { nolens_detail: null },
        procedura: {},
        nolens: false,
        dittalenti: [],
        listalenti: [],
        listapromo: [],
        rangeCalibro: [],
        lenssupplier: [
          { title: 'A magazzino', value: 'magazzino' },
          { title: 'Invio disegno per costruzione/precalibratura', value: 'disegno' },
          { title: 'Lenti non precalibrate o spessorate', value: 'diametro' },
        ],

        headers: [
          { text: '', value: 'modello', align: 'right text-caption', width: '30%' },
          { text: '', value: 'forma', align: 'left text-caption', sortable: false },

        ],
        search: '',
        showForme: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
          signed: v => (!v || /^[+-]\d*\.?\d*$/.test(v)) || 'E` richiesto il segno + o -',
          range: (min, max) => (v) => {
            if (!v) {
              return true
            }
            var num = parseFloat(v)
            return (num >= min && num <= max) || `Richiesto valore tra ${min} e ${max}`
          },
          // stepper: (step) => (v) => {
          //   if (!v) {
          //     return true
          //   }
          //   var num = parseFloat(v)
          //   var tolerance = 0.01
          //   if (step === 0.25) {
          //     tolerance = 0.009
          //   }

          //   var valore = Math.abs(num % step).toFixed(10)
          //   console.log(num, step, valore)
          //   if (valore < tolerance) {
          //     valore = 0
          //   }
          //   // console.log(40 % 0.01)
          //   // due to floating-point precision issues, the result is not exactly zero
          //   return (valore === 0) || `Richiesto multiplo di ${step}`
          // },

          stepper: (step) => (v) => {
            if (!v) {
              return true
            }

            // Scale factor const scale = 100; // Multiply var to convert it to an integer
            var num = parseFloat(v) * 100
            var stp = step * 100

            var valore = ((Math.abs(num % stp)) / 100).toFixed(2)

            return (+valore === 0) || `Richiesto multiplo di ${step}`
          },
          requiredOn: (field) => (v) => {
            if (this.$refs[field] && this.$refs[field]?.value) {
              return !!v || `Richiesto un valore perchè ${field.substr(3).toUpperCase()} non e' vuoto`
            }
            return true
          },
          requiredIf: (vero) => (v) => {
            if (vero) {
              return !!v || 'Valore richiesto'
            }
            return true
          },
        },
        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      config () {
        return Config
      },
      promoMarca () {
        return this.listapromo.filter((promo) => {
          return promo.tipo === 'MARCA'
        })
      },
      marcheLenti () {
        var marche = this.dittalenti
        if (this.lens.lendor === 'PD') {
          marche = []
          this.listapromo.map((promo) => {
            if (marche.findIndex((item) => item.marca === promo.smarca) === -1) {
              // return { ditta: promo.marca_lente.trim(), marca: promo.smarca }
              marche.push({ ditta: promo.marca_lente.trim(), marca: promo.smarca })
            }
          })
        }
        console.log('marcheLenti', marche)
        return marche
      },
      monpro () {
        var monpro = []
        if (this.lens.lendor === 'PD') {
          monpro = this.listapromo.map((promo) => {
            return promo.focale
          })
        }
        return [...new Set(monpro)]
      },
      tiptrt () {
        var tiptrt = []
        if (this.lens.lendor === 'PD') {
          tiptrt = this.listapromo.map((promo) => {
            return { tipoLente: promo.tipo_lente, trtLente: promo.trattamento_lente }
          })
        }
        return [...new Set(tiptrt)]
      },
    },
    watch: {
      order: {
        handler (newval) {
          if (this.alive && this.order.lens) { this.lens = JSON.parse(JSON.stringify(this.order.lens)) }
        },
        deep: true,
      },
      lens: {
        handler (newval) {
          this.validate()
          console.log('lens', newval, this.$refs.formlenti.validate())
          this.$nextTick(() => {
            if (newval && this.lens.desmod && this.$refs.formlenti.validate()) {
              console.log('EMIT LENSCOMPLETE')
              this.$emit('lensComplete', this.lens)
            } else {
              this.$emit('lensComplete', false)
            }
          })
        },
        deep: true,
      },
      // monpro (newval, oldval) {
      //   if (newval.length === 1) {
      //     this.lens.monpro = newval[0]
      //   }
      // },

      // order (newval) {
      //   this.lens = JSON.parse(JSON.stringify(this.order.lens))
      // },
      // lens (newval) {
      //   this.validate()
      //   if (newval && this.validForm) {
      //     this.$emit('lensComplete', this.lens)
      //   }
      // },
    },
    mounted () {
      console.log('mount sceltalenti')
      this.load_data()
      this.load_listalenti()
      this.load_listapromo()
      if (this.order.lens) { this.lens = JSON.parse(JSON.stringify(this.order.lens)) }
      if (this.lens.desmod !== '') { this.lensClick({ init: true, modello: this.lens.desmod, calibro: this.lens.calibr }) }
      if (this.lens.desmod === 'NN') { this.nolens = true }
    },
    beforeDestroy () {

    },
    methods: {
      ftDecimal (campo, fix = 2) {
        var valore = this.lens[campo]
        console.log('ftDecimal', campo, valore)
        var newval = null
        if (!valore || valore.trim() === '' || isNaN(parseFloat(valore))) {
          newval = null
        } else if (valore >= 0 && !['d_semidi', 's_semidi', 'd_altezz', 's_altezz'].includes(campo)) {
          newval = '+' + parseFloat(valore).toFixed(fix)
        } else {
          newval = parseFloat(valore).toFixed(fix)
        }

        this.lens[campo] = newval
      },
      validate () {
        this.$refs.formlenti.validate()
      },
      reset () {
        this.$refs.formlenti.reset()
      },
      resetValidation () {
        this.$refs.formlenti.resetValidation()
      },
      load_data () {
        this.loading = true
        var codsog = this.auth.userinfo.codsog
        var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
        var codcli = `${codsog}${coddes}`
        engine.get_dittalenti(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.dittalenti = result.data
          })
          .catch((errore) => {
            console.log('get_dittalenti err: ', errore)
          }).finally(() => { this.loading = false })
      },
      load_listalenti () {
        this.loading = true
        engine.get_listalenti(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listalenti = result.data
          })
          .catch((errore) => {
            console.log('get_listalenti err: ', errore)
          }).finally(() => { this.loading = false })
      },
      load_listapromo () {
        this.loading = true
        engine.get_listapromo(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listapromo = result.data
          })
          .catch((errore) => {
            console.log('get_listapromo err: ', errore)
          }).finally(() => { this.loading = false })
      },
      lensClick (item) {
        if (this.$linea().label === 'JOY') {
          this.$set(this.lens, 'desmod', item.modello)
          this.rangeCalibro = item.calibro?.split(',')
        } else if (this.$linea().label === 'JOYBAB') {
          this.$set(this.lens, 'desmod', item.modello)
          this.rangeCalibro = item.calibro?.split(',')
        } else {
          // linea: SWF
          this.$set(this.lens, 'desmod', item.modello)
          // this.setRangeCalibro(item.calibro)
          this.rangeCalibro = [44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63]
        }
        this.$set(this.lens, 'calibr', null)
        if (item.init) { this.$set(this.lens, 'calibr', item.calibro) }
        this.$forceUpdate()
        this.showForme = false
      },
      setDesmod () {
        if (this.nolens) {
          this.$set(this.lens, 'desmod', 'NN')
          if (this.$linea().label === 'JOY') {
            this.rangeCalibro = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
          } else if (this.$linea().label === 'JOYBAB') {
            // linea JOYBABY
            this.rangeCalibro = ['XS', 'S']
          } else {
            // linea SWF
            this.rangeCalibro = [46, 47, 48, 49, 50, 51, 52, 53, 54]
          }
          this.$set(this.lens, 'calibr', null)
        } else {
          this.$set(this.lens, 'desmod', null)
        }
      },
      setTipTrt (item) {
        console.log('setTipTrt', item)
        if (!item) {
          item = { tipoLente: null, trtLente: null }
        }
        this.$set(this.lens, 's_destip', item.tipoLente)
        this.$set(this.lens, 'd_destip', item.tipoLente)
        this.$set(this.lens, 's_destrt', item.trtLente)
        this.$set(this.lens, 'd_destrt', item.trtLente)
      },
      setRangeCalibro (calibro) {
        // creo range di -4, +4 a partire dal calibro base
        this.rangeCalibro = Array.from({ length: 9 }, (_, index) => parseInt(calibro) - 4 + index)
      },
      setDistan () {
        this.$set(this.lens, 'distan', (+(this.lens.d_semidi ?? 0) + +(this.lens.s_semidi ?? 0)).toFixed(1))
      },
      setFilter (pos) {
        this.setDistan()

        if (pos === 'OD' && this.lens.d_filtro) {
          this.$set(this.lens, 'd_vsfero', null)
          this.$set(this.lens, 'd_cilind', null)
          this.$set(this.lens, 'd_vlasse', null)
          this.$set(this.lens, 'd_addizi', null)
          this.$set(this.lens, 'd_prisma', null)
          this.$set(this.lens, 'd_vgradi', null)
          this.$set(this.lens, 'd_semidi', null)
          this.$set(this.lens, 'd_altezz', null)
        }

        if (pos === 'OS' && this.lens.s_filtro) {
          this.$set(this.lens, 's_vsfero', null)
          this.$set(this.lens, 's_cilind', null)
          this.$set(this.lens, 's_vlasse', null)
          this.$set(this.lens, 's_addizi', null)
          this.$set(this.lens, 's_prisma', null)
          this.$set(this.lens, 's_vgradi', null)
          this.$set(this.lens, 's_semidi', null)
          this.$set(this.lens, 's_altezz', null)
          this.$set(this.lens, 'tabint', null)
        }

        if (this.lens.d_filtro && this.lens.s_filtro) {
          this.lens.fornitura_lente = null
          this.$set(this.lens, 'distan', null)
        }
        // ricalcolo DI

        this.$nextTick(() => {
          this.validate()
        })
      },
      setDittaLente (smarca) {
        console.log('setDittaLente', smarca, this.dittalenti)
        const item = this.dittalenti.find((item) => item.marca === smarca)
        this.$set(this.lens, 'identi', item?.idcode)
        this.$set(this.lens, 'altra_ditta_lenti', item?.ditta || smarca)
        if (smarca === 'AL') {
          this.$set(this.lens, 'altra_ditta_lenti', null)
        }
        this.$forceUpdate()
      },
      setDiamet (value) {
        this.$set(this.lens, 'diamet', value); this.validate(); this.$forceUpdate()
      },
      changeLendor (newVal) {
        console.log('lendornewVal', newVal)

        this.$set(this.lens, 'smarca', null)
        this.$set(this.lens, 'monpro', null)
        this.$set(this.lens, 'tiptrt', null)

        if (newVal === 'PD') {
          if (this.marcheLenti.length === 1) {
            this.$set(this.lens, 'smarca', this.marcheLenti[0].marca)
            this.setDittaLente(this.marcheLenti[0].marca)
          }
          if (this.monpro.length === 1) {
            this.$set(this.lens, 'monpro', this.monpro[0])
          }
        }
        this.setTipTrt(false)
      },
      // onSubmit () {
      //   this.valid = this.$refs.form.validate()
      //   if (this.valid) {
      //     console.log('send', this.lens)
      //     const data = { lens: this.lens, cliente: this.cliente }
      //     engine.sendRiparazione(data).then((result) => {
      //       if (result) {
      //         // alert('Form has been submitted!')
      //         console.log('sendRiparazione', result)
      //         this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
      //       }
      //     })
      //       .catch((errore) => {
      //         // eslint-disable-next-line no-console
      //         console.error('ERR####', errore)
      //       })
      //     return
      //   }
      //   this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
      //   this.$vuetify.goTo(0) // scroll top
      //   console.log('send invadlid', this.lens)
      // },
    },
  }

</script>
